import clsx from "clsx";
import { graphql } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import React, { DetailedHTMLProps, FC, HTMLAttributes } from "react";

import { Tag } from "../../tag";

export interface FlatCardProps
  extends Queries.FlatCardDataFragment,
    Pick<DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>, "className"> {
  variant?: "light" | "dark";
  showBody?: boolean;
}

export const FlatCard: FC<FlatCardProps> = ({
  title,
  tag,
  image,
  variant = "dark",
  showBody = true,
  className,
}) => {
  return (
    <div className={clsx(["w-full flex flex-col", className])}>
      <div className="shadow-lg rounded-4xl overflow-hidden h-[400px] 2xl:h-[460px]">
        {image?.gatsbyImageData && (
          <GatsbyImage
            image={image?.gatsbyImageData}
            alt={title ?? ""}
            objectFit="cover"
            className="w-full h-full"
          />
        )}
      </div>
      <div
        className={clsx(
          "w-full flex flex-col gap-3 justify-center items-center p-6 transition-opacity",
          { "opacity-0": !showBody }
        )}
      >
        {tag && <Tag variant={variant}>{tag}</Tag>}
        <div
          className={clsx("text-2xl font-normal text-center", {
            "text-white": variant === "light",
          })}
        >
          {title}
        </div>
      </div>
    </div>
  );
};

export const query = graphql`
  fragment FlatCardData on ContentfulFlatCard {
    __typename
    image {
      gatsbyImageData
    }
    title
    tag
  }
`;
